import queryString from 'query-string'

function getQueryParamsFromHash(){
  const [_, query] = window.location.hash.split('?')
  const parsed = queryString.parse(query)
  return parsed || {}
}

export default getQueryParamsFromHash